export default "__VITE_ASSET__2wgz$uNm__"